export default "__VITE_ASSET__23kSfEE0__"